import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Wrapper = styled.div`
  position: relative;
  background: ${(props) => props.theme.color.blue.light};
  width: 90%;

  margin: auto;
  position: relative;
  padding: 0;
  max-width: 1000px;
  padding-left: 450px;
  border-radius: 15px;

  ${mediaQuery('medium')} {
    padding: 0;
  }
`;

export const ImageWrapper = styled.div`
  position: absolute;
  left: -30px;
  bottom: -30px;
  width: 370px;
  img {
    width: 100%;
  }
  ${mediaQuery('medium')} {
    display: none;
  }
`;

export const FromWrapper = styled.div`
  border-radius: 15px;
  overflow: hidden;
`;
